import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getNews(
  search = "",
  createDateFrom = "",
  createDateTo = "",
  excludeNewsId?: number
): Promise<AxiosResponse<any, any>> {
  const params: {
    search?: string,
    createDateFrom?: string,
    createDateTo?: string,
    excludeNewsId?: number
  } = {};
  
  if (search) params.search = search;
  if (createDateFrom) params.createDateFrom = createDateFrom;
  if (createDateTo) params.createDateTo = createDateTo;
  if (excludeNewsId) params.excludeNewsId = excludeNewsId;

  return axiosInstance.get(`News/ListNews`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function deleteNews(newsId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`News/SoftdeleteNews/${newsId}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function createNews(formData: FormData): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`News/CreateNews`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
    },
  });
}

export function getNewsDetail(newsId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`News/GetNews/${newsId}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

// En news/index.tsx, agregar la función updateNews
export function updateNews(
  newsId: number, 
  formData: FormData
): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`News/UpdateNews/${newsId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
    },
  });
}

export function toggleNewsVisibility(newsId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`News/VisibilityNews/${newsId}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}